export const LAWYER_VIEW = '/abogado/:uid';
export const LAWYERFIRM_VIEW = '/despacho/:uid';
export const LAWYER_PREVIEW_VIEW = '/preview';
export const ADDITIONAL_INFO = '/informacion-adicional/';
export const ARTICLES = '/articulos';
export const ARTICLE_VIEW = '/articulos/:category/:postId';
export const SIGNIN = '/ingreso-abogados';
export const NEW_PASSWORD = '/nueva-contrasena';
export const RECOVER_PASSWORD = '/ingreso-abogados/recuperar-password';
export const SIGNUP = '/registro-abogados';
export const SIGNUP_LAWYER_INFO = '/registro-abogados/datos-abogado';
export const SIGNUP_LAWYER = '/registro-abogados/abogado';
export const SIGNUP_LAWFIRM_INFO = '/registro-abogados/datos-despacho';
export const SIGNUP_LAWFIRM = '/registro-abogados/despacho';
export const HOME = '/dashboard';
export const PROFILE = '/dashboard/perfil';
export const ANALYTICS = '/dashboard/analytics';
export const MEMBERSHIP = '/dashboard/membresia';
export const MEMBERSHIP_HISTORY = '/dashboard/membresia/historial';
export const MEMBERSHIP_PAYMETHOD = '/dashboard/membresia/metodo-pago';
export const MEMBERSHIP_INVOICES = '/dashboard/membresia/facturas';
export const MESSAGES = '/dashboard/mensajes';
export const ECONOMIC_PROPOSAL = '/dashboard/propuesta-economica';
export const OPINIONS = '/dashboard/opiniones';
export const NOTIFICATIONS = '/dashboard/notificaciones';
export const ACCOUNT = '/dashboard/cuenta';
export const TERMS_CONDITIONS = '/dashboard/terminos-y-condiciones';
export const SIGNOUT = '/salir';
export const BILLING = '/dashboard/facturacion';
export const PROFILEPROGRESS = '/dashboard/perfil/progreso';

// Payments
export const PAYMENTS = '/dashboard/payments'
//Tutorial
export const TUTORIALES = '/dashboard/tutoriales';

// Admin
export const SIGNIN_ADMIN = '/ingreso-administrador';
export const RECOVER_PASSWORD_ADMIN = '/ingreso-administrador/recuperar-password-admin';
export const NEW_PASSWORD_ADMIN = '/ingreso-administrador/nueva-contrasena-admin';

export const DASHBOARD_ADMIN = '/dashboard-admin';
export const ADMIN_LAWYER = '/dashboard-admin/abogado';
export const ADMIN_LAWYER_FIRM = '/dashboard-admin/despacho';
export const ADMIN_CLIENT = '/dashboard-admin/client';
export const ADMIN_CONTACT_CENTER = '/dashboard-admin/contact-center';

// Client
export const SIGN_IN_MAIN_CLIENT = '/usuario';

export const SIGN_IN_CLIENT = '/usuario/inicio-sesion';
export const SIGN_IN_EMAIL_CLIENT = '/usuario/email-sesion';
export const NEW_PASSWORD_CLIENT = '/usuario/nueva-contrasena-usuario';
export const RECOVER_PASSWORD_CLIENT = '/usuario/restablecer-password';

export const SIGN_UP_CLIENT = '/usuario-registro';
export const SIGN_UP_EMAIL_CLIENT = '/usuario-registro/email-registro';
export const SIGN_UP_INFO_CLIENT = '/usuario-registro/info-registro';

export const SEARCH_LAWYER = '/busqueda/';
export const NOTIFICATIONS_CLIENT = '/notificaciones';
export const LAWYERS_CONTACTED = '/dashboard-cliente';
export const CLIENT_ACCOUNT = '/cliente-cuenta';

export const LEGAL_MATTERS = '/asuntos-legales';
export const LEGAL_MATTERS_SPECIALTY = '/asuntos-legales/:speciality';
export const LEGAL_MATTERS_DETAIL = '/asuntos-legales/:speciality/:id';

export const COMUNITY = '/comunidad';
export const QUESTION = '/comunidad/pregunta/:id';


//Landings
export const LANDING_PAGE_CLIENT = '/';
export const LANDING_PAGE = '/lp-abogados';
export const LANDING_PAGE_300 = '/membresia-lp';
export const LANDING_PAGE_FREE = '/membresia-gratis';

export const MEMBERSHIPS_LAWYERS = '/membresias-abogados';
export const ERROR_404 = '/error_404';
export const EMPTYS = '/emptys';
export const THANKYOU_PAGE = '/membresia-bienvenido';
export const CONGRATULATIONS_PAGE = '/webinartp';
export const CONGRATULATIONS_LEADS_PAGE = '/leadstp';

// New landings
export const LANDING1 = '/registro-demo';
export const LANDING2 = '/registros-membresia';
export const WEBINAR = '/webinar';
export const LEADS = '/leads';
export const FREEMIUM_MEMBERSHIP = '/membresia-freemium';
